/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
 import React from 'react';
 import _ from 'lodash';
 import { Button, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
 import {
   checkQuarterValidation,
   convertQuaterToDate,
   isDateToQuarter,
   quarterTest1,
   quarterTest2,
 } from '../../../../SharedModules/CommonUtilities/commonUtilities';
 import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
 import {
   CONTRACT_START_QTR,
   DRUG_FAMILY_DESC_REQUIRED,
   DRUG_FAMILY_NAME_REQUIRED,
   INVALID_QTR_ERR_MSG,
   MFG_ID_FOR_CONTRACT,
   MFG_NAME_FOR_CONTRACT,
   PLAN_TYPE_DESC_REQUIRED,
   PLAN_TYPE_REQUIRED,
   QUARTER_VALUE_REQUIRED,
   REBATE_PGM_CODE_DESC_REQUIRED,
   REBATE_PROGRAM_REQUIRED,
   REBATE_PROG_CD_REQ,
   VALIDATE_QUARTER_VALUE,
 } from '../../../../SharedModules/Errors/constantMessageData';
 import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
 import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
 import {
   storeBlurState,
   storeOverlapState,
   storePriceDetailsErrors,
   storePriceLevelErrors,
 } from '../store/actions';
 import { TextField } from '@material-ui/core';
 import {
   DialogActions,
   DialogContent,
   DialogContentText,
   Dialog,
 } from '@material-ui/core';
 import Axios from 'axios';
 import * as serviceEndPoint from '../../../../SharedModules/services/service';
 
 export const priceLevelonBlurValidations = (
   value,
   getErrorMsgs,
   dispatch,
   setInputValues,
   type
 ) => {
   let localErr = getErrorMsgs || [];
   const rebatePgm = value?.rebateProgram;
   const quarter = value?.quarter;
 
   if (type === 'rebateProgram') {
     if (!rebatePgm || rebatePgm === '-1') {
       localErr = localErr.filter((item) => item.field !== 'rebateProgram');
       localErr.push({
         field: 'rebateProgram',
         errorType: 'rebateRequired',
         message: REBATE_PROGRAM_REQUIRED,
       });
     } else {
       localErr = localErr.filter((item) => item.field !== 'rebateProgram');
     }
   }
 
   if (type === 'quarter') {
     if (quarter && !_.isEmpty(quarter) && !_.isNaN(quarter)) {
       const indexOf = !_.isEmpty(localErr)
         ? _.findIndex(localErr, {
             field: 'quarter',
             errorType: 'required',
           })
         : null;
 
       if (!_.isNull(indexOf) && indexOf >= 0) {
         localErr.splice(indexOf, 1);
       }
       if (quarterTest1.test(quarter) || quarterTest2.test(quarter)) {
         const indexOf = !_.isEmpty(localErr)
           ? _.findIndex(localErr, {
               field: 'quarter',
               errorType: 'invalidFormat',
             })
           : null;
 
         if (!_.isNull(indexOf) && indexOf >= 0) {
           localErr.splice(indexOf, 1);
         }
         localErr = localErr.filter((item) => item.field !== 'quarter');
         setInputValues((prev) => ({
           ...prev,
           quarter: quarter?.toUpperCase(),
         }));
       } else {
         localErr = localErr.filter((item) => item.field !== 'quarter');
         localErr.push({
           field: 'quarter',
           errorType: 'invalidFormat',
           message: INVALID_QTR_ERR_MSG,
         });
       }
     } else {
       localErr = localErr.filter((item) => item.field !== 'quarter');
       localErr.push({
         field: 'quarter',
         errorType: 'required',
         message: QUARTER_VALUE_REQUIRED,
       });
     }
   }
   dispatch(storePriceLevelErrors(localErr));
   return localErr;
 };
 
 export const priceLevelonClickValidations = (
   value,
   dispatch,
   setInputValues
 ) => {
   let localErr = [];
   const quarter = value?.quarter;
   // localErr = rebatePgmValidation(value?.rebateProgram, localErr, dispatch);
   // localErr = quarterValidation(value?.quarter, localErr, dispatch);
 
   // rebate pgm
   if (value?.rebateProgram !== '-1') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'rebateProgram',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'rebateProgram',
       errorType: 'required',
       message: REBATE_PROGRAM_REQUIRED,
     });
   }
 
   // quarter
   if (quarter && !_.isEmpty(quarter) && !_.isNaN(quarter)) {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'quarter',
           errorType: 'required',
         })
       : null;
 
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
     if (quarterTest1.test(quarter) || quarterTest2.test(quarter)) {
       const indexOf = !_.isEmpty(localErr)
         ? _.findIndex(localErr, {
             field: 'quarter',
             errorType: 'invalidFormat',
           })
         : null;
 
       if (!_.isNull(indexOf) && indexOf >= 0) {
         localErr.splice(indexOf, 1);
       }
       localErr = localErr.filter((item) => item.field !== 'quarter');
       setInputValues((prev) => ({
         ...prev,
         quarter: quarter?.toUpperCase(),
       }));
     } else {
       localErr = localErr.filter((item) => item.field !== 'quarter');
       localErr.push({
         field: 'quarter',
         errorType: 'invalidFormat',
         message: INVALID_QTR_ERR_MSG,
       });
     }
   } else {
     localErr = localErr.filter((item) => item.field !== 'quarter');
     localErr.push({
       field: 'quarter',
       errorType: 'required',
       message: QUARTER_VALUE_REQUIRED,
     });
   }
   const unique = [...new Set(localErr)];
   dispatch(storePriceLevelErrors(unique));
 };
 
 export const priceDetailsBlurValidations = (
   value,
   name,
   errMsg,
   getErrorMsgs,
   dispatch
 ) => {
   let localErr = getErrorMsgs || [];
   if (value[name] !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: name,
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: name,
       errorType: 'required',
       message: errMsg,
     });
   }
 
   dispatch(storePriceDetailsErrors(localErr));
 };
 
 export const priceDetailsInputFields = [
   {
     label: 'Plan Type',
     name: 'planType',
     errMsg: PLAN_TYPE_REQUIRED,
     maxLength: false,
   },
   {
     label: 'Plan Type Description',
     name: 'planTypeDesc',
     errMsg: PLAN_TYPE_DESC_REQUIRED,
     maxLength: false,
   },
   {
     label: 'Rebate Program Code',
     name: 'rebatePgmCode',
     errMsg: REBATE_PROG_CD_REQ,
     maxLength: 38,
   },
   {
     label: 'Rebate Program Code Decription',
     name: 'rebatePgmCodeDesc',
     errMsg: REBATE_PGM_CODE_DESC_REQUIRED,
     maxLength: false,
   },
   {
     label: 'Manufacturer ID',
     name: 'manufactId',
     errMsg: MFG_ID_FOR_CONTRACT,
     maxLength: 10,
   },
   {
     label: 'Manufacturer Name',
     name: 'manufactName',
     errMsg: MFG_NAME_FOR_CONTRACT,
     maxLength: false,
   },
   {
     label: 'Quarter',
     name: 'quarter',
     errMsg: QUARTER_VALUE_REQUIRED,
     maxLength: 6,
   },
   {
     label: 'Drug Family Name',
     name: 'drugFamilyName',
     errMsg: DRUG_FAMILY_NAME_REQUIRED,
     maxLength: 120,
   },
   {
     label: 'Drug Family Description',
     name: 'drugFamilyDesc',
     errMsg: DRUG_FAMILY_DESC_REQUIRED,
     maxLength: 255,
   },
 ];
 
 export const priceDetailsClickValidations = (value, dispatch) => {
   let localErr = [];
 
   // planType
   if (value.planType !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'planType',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'planType',
       errorType: 'required',
       message: PLAN_TYPE_REQUIRED,
     });
   }
 
   // planTypeDesc
   if (value.planTypeDesc !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'planTypeDesc',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'planTypeDesc',
       errorType: 'required',
       message: PLAN_TYPE_DESC_REQUIRED,
     });
   }
 
   // rebatePgmCode
   if (value.rebatePgmCode !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'rebatePgmCode',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'rebatePgmCode',
       errorType: 'required',
       message: REBATE_PROG_CD_REQ,
     });
   }
 
   // rebatePgmCodeDesc
   if (value.rebatePgmCodeDesc !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'rebatePgmCodeDesc',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'rebatePgmCodeDesc',
       errorType: 'required',
       message: REBATE_PGM_CODE_DESC_REQUIRED,
     });
   }
 
   // manufactId
   if (value.manufactId !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'manufactId',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'manufactId',
       errorType: 'required',
       message: MFG_ID_FOR_CONTRACT,
     });
   }
 
   // manufactName
   if (value.manufactName !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'manufactName',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'manufactName',
       errorType: 'required',
       message: MFG_NAME_FOR_CONTRACT,
     });
   }
 
   // quarter
   if (value.quarter !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'quarter',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'quarter',
       errorType: 'required',
       message: QUARTER_VALUE_REQUIRED,
     });
   }
 
   // drugFamilyName
   if (value.drugFamilyName !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'drugFamilyName',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'drugFamilyName',
       errorType: 'required',
       message: DRUG_FAMILY_NAME_REQUIRED,
     });
   }
 
   // drugFamilyDesc
   if (value.drugFamilyDesc !== '') {
     const indexOf = !_.isEmpty(localErr)
       ? _.findIndex(localErr, {
           field: 'drugFamilyDesc',
           errorType: 'required',
         })
       : null;
     if (!_.isNull(indexOf) && indexOf >= 0) {
       localErr.splice(indexOf, 1);
     }
   } else {
     localErr.push({
       field: 'drugFamilyDesc',
       errorType: 'required',
       message: DRUG_FAMILY_NAME_REQUIRED,
     });
   }
   dispatch(storePriceDetailsErrors(localErr));
 };
 
 export const tableData = [
   {
     mfgId: '00003',
     mfgName: 'sample data',
     mfgTypeCd: 'C',
     defEnrollmentTimingCd: '-1',
     defPricingTimingCd: '-1',
     defCollectionMediumCd: null,
     defPaperFinalQtr: null,
     defPrintImageFinalQtr: null,
     defCmsElectFinalQtr: null,
     defNcpdpSummaryFinalQtr: null,
     defNcpdpClaimOwnFinalQtr: null,
     defNcpdpClaimMbFinalQtr: null,
     defPaperInd: 0,
     defPrintImageInd: null,
     defCmsElectInd: 1,
     defNcpdpSummaryInd: 0,
     defNcpdpClaimOwnInd: 0,
     defNcpdpClaimMbInd: 0,
     addrDiscrepancyInd: null,
     rebatewebParticipantInd: null,
     defWacPct: null,
     lastUpdateDt: 1672631760000,
     lastUpdateUserId: 'DRAMS',
     corrLinkId: 68,
     shortDescr: null,
     contractSeqNum: null,
   },
   {
     mfgId: '00004',
     mfgName: 'sample data',
     mfgTypeCd: 'C',
     defEnrollmentTimingCd: 'END',
     defPricingTimingCd: 'AVG',
     defCollectionMediumCd: null,
     defPaperFinalQtr: null,
     defPrintImageFinalQtr: null,
     defCmsElectFinalQtr: null,
     defNcpdpSummaryFinalQtr: null,
     defNcpdpClaimOwnFinalQtr: null,
     defNcpdpClaimMbFinalQtr: null,
     defPaperInd: 1,
     defPrintImageInd: null,
     defCmsElectInd: 1,
     defNcpdpSummaryInd: 1,
     defNcpdpClaimOwnInd: 1,
     defNcpdpClaimMbInd: 0,
     addrDiscrepancyInd: null,
     rebatewebParticipantInd: null,
     defWacPct: 123,
     lastUpdateDt: 1672631760000,
     lastUpdateUserId: 'DRAMS',
     corrLinkId: 77,
     shortDescr: null,
     contractSeqNum: null,
   },
 ];
 
 export const planTypeData = [
   {
     name: 'Commercial',
     value: 'COMM',
   },
   {
     name: 'Supplemental',
     value: 'SUPP',
   },
 ];
 export const drugData = [
   {
     name: 'Select A Drug Family',
     value: 'drug',
   },
   {
     name: 'All',
     value: 'all',
   },
 ];
 
 export const gridBlurValidations = (cellInfo, getErrorMsgs, dispatch) => {
   const name = cellInfo.column.colId;
   const value = cellInfo.value;
   let localErr = getErrorMsgs;
   if (name === 'startQtr') {
     if (value && !_.isEmpty(value) && !_.isNaN(value)) {
       const indexOf = !_.isEmpty(localErr)
         ? _.findIndex(localErr, {
             field: 'startQtr',
             errorType: 'required',
           })
         : null;
 
       if (!_.isNull(indexOf) && indexOf >= 0) {
         localErr.splice(indexOf, 1);
       }
       if (quarterTest1.test(value) || quarterTest2.test(value)) {
         const indexOf = !_.isEmpty(localErr)
           ? _.findIndex(localErr, {
               field: 'startQtr',
               errorType: 'invalidFormat',
             })
           : null;
 
         if (!_.isNull(indexOf) && indexOf >= 0) {
           localErr.splice(indexOf, 1);
         }
         localErr = localErr.filter((item) => item.field !== 'startQtr');
         // setInputValues((prev) => ({
         //   ...prev,
         //   startQtr: startQtr?.toUpperCase(),
         // }));
       } else {
         localErr = localErr.filter((item) => item.field !== 'startQtr');
         localErr.push({
           field: 'startQtr',
           errorType: 'invalidFormat',
           message: INVALID_QTR_ERR_MSG,
         });
       }
     } else {
       localErr = localErr.filter((item) => item.field !== 'startQtr');
       localErr.push({
         field: 'startQtr',
         errorType: 'required',
         message: CONTRACT_START_QTR,
       });
     }
   }
   dispatch(storePriceDetailsErrors(localErr));
 };
 
 export const generateQuarter = (d) => {
   var date = new Date();
   var month = date.getMonth() + 1;
   var year = date.getFullYear();
   let quarter = Math.ceil(month / 3);
   return `${quarter}Q${year}`;
 };
 
 const hasDuplicates = (array = []) => {
   return new Set(array).size !== array.length;
 };
 
 export const levelValidation = (array = []) => {
   const temp = array.map((item) => item.levelId === '');
   return temp.includes(true);
 };
 
 export const startQtrValidation = (array = []) => {
   const temp = array.map((item) => item.startQtr === '');
   return temp.includes(true);
 };
 

 export const isStartQtrValid = (array = [], type = false) => {
  const temp = array.map((item) => 
  checkStartQuarterValidation(item.startQtr));
  return type ? temp : temp.includes(false);
};


export const checkStartQuarterValidation = (value) => {

if(value !== ''){
    const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (format.test(value)) {
      return false;
    }
    const reTest = /[1-4]{1}[qQ]{1}\d{4}$/;
    const reTest2 = /[1-4]{1}[qQ]{1}\d{2}$/;
    if (reTest.test(value) || reTest2.test(value)) {
      return true;
    }
    return false;
  }

};
export const isEndQtrValid = (array = [], type = false) => {

  const temp = array.map((item) => 
  item.endQtr ? checkEndQuarterValidation(item.endQtr) : true)
  return type ? temp : temp.includes(false);
};

export const checkEndQuarterValidation = (value) => {

  if(value === ''){
    return true;
  }else{
    const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (format.test(value)) {
      return false;
    }
    const reTest = /[1-4]{1}[qQ]{1}\d{4}$/;
    const reTest2 = /[1-4]{1}[qQ]{1}\d{2}$/;
    if (reTest.test(value) || reTest2.test(value)) {
      return true;
    }
    return false;
  }

};

 export const endQtrValidation = (array = []) => {
   const temp = array.map((item) => item.endQtr === '');
   return temp.includes(true);
 };
 
 export const seperateLevels = (array, key) => {
   return array.reduce(function (rv, x) {
     (rv[x[key]] = rv[x[key]] || []).push(x);
     return rv;
   }, {});
 };
 
 export const quarterOverlapValidation = (array = []) => {
   const data = seperateLevels(array, 'levelId');
   const keys = Object.keys(data);
   const booleanArr = keys.map((item) => {
     const dd = data[item];
     const isDuplicate = hasDuplicates(
       dd.filter((item2) => item2.startQtr !== '').map((item3) => item3.startQtr)
     );
     return isDuplicate;
   });
   // returns array i.e ['true', 'false'] if true then same qtr exist for same levelId
   return booleanArr;
 };
 
 export const isStartQtrGreater = (array = []) => {
   if (!startQtrValidation(array) && !endQtrValidation(array)) {
     const temp = array.map(
       (item) =>
         convertQuaterToDate(item.startQtr) > convertQuaterToDate(item.endQtr)
     );
     return temp.includes(true);
   }
   return false;
 };
 
 export const getGridTwo = (priceDetailGrids) => {
   if (priceDetailGrids && Object.keys(priceDetailGrids).length > 0) {
     const { getDetailsGridTwo } = priceDetailGrids.rebateProgramLevel[0];
     const arr =
       getDetailsGridTwo.length > 0 &&
       getDetailsGridTwo.map((item, index) => {
         return {
           ...item,
           endQtr: item.endQtr ? item.endQtr : null,
           deleteRecord: 0,
           rowIndex: index,
         };
       });
     return Array.isArray(arr) ? arr : [];
   }
 };
 
 export const clearCellErrors = (blurPageState, overlapStateErr, dispatch) => {
   // clear cell errors
   let errors = [...blurPageState];
   errors = errors.map((item) => {
     return {
       ...item,
       startQtrErr: false,
       endQtrErr: false,
       rangeInvalidErr: false,
       levelIdErr: false,
     };
   });
   dispatch(storeBlurState(errors));
 
   // clear overlap cell errors
   let overlapErrs = [...overlapStateErr];
   overlapErrs = overlapErrs.map((item) => {
     return {
       ...item,
       startQtrOverlap: false,
     };
   });
   dispatch(storeOverlapState(overlapErrs));
 };
 